/**
 * Copy for the team invoice celebration.
 *
 * This one sentence is the whole point of the feature, so it lives here as a
 * pure function rather than inline in the modal — it is the piece worth pinning
 * with tests.
 */

export function formatAmount(amount) {
  return Number(amount || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
}

/** The line under "Way to go, team!". */
export function celebrationSummary(celebrations = []) {
  if (celebrations.length === 1) {
    const [only] = celebrations;
    return `We just invoiced ${only.customerName} ${formatAmount(only.amount)}.`;
  }
  const total = celebrations.reduce((sum, c) => sum + Number(c.amount || 0), 0);
  return `We just sent ${celebrations.length} invoices totalling ${formatAmount(total)}.`;
}
